import CloseButton from './CloseButton'
import PropTypes from 'prop-types'
import React from 'react'

const ModalHeader = ({ children, dismissable, onClose }) => (
  <div className="fv-modal-header">
    {children}
    {dismissable && <CloseButton onClick={onClose} />}
  </div>
)

ModalHeader.propTypes = {
  children: PropTypes.node,
  dismissable: PropTypes.bool.isRequired
}

ModalHeader.defaultProps = {
  dismissable: true
}

export default ModalHeader



// WEBPACK FOOTER //
// ../src/components/fv-ui/ModalHeader.js